export const info = {
  maxInnerWidth: {
    largeMobile: 576,
    tablet: 984,
    desktop: 1288,
    largeDesktop: 1600,
  },
} as const;
